import React, { useState } from "react";

function InputComponent2({ type, value, label, error, disabled, onchange, name, maxLength, notRequired }) {
  const [inputType, setInputType] = useState(type ? type : "text");

  const handlepasswordIcon = (inputType) => {
    if (inputType == "password") {
      setInputType("text");
    } else {
      setInputType("password");
    }
  };
  return (
    <div>
      <div className="form_bx_stack mb-1 ">
        <label className="mb-0 text_m1 text-black font_15">{label}</label>
        {notRequired ? '' : <span className="text-danger">*</span>}
        
        <div
          className={`data w-100 mt-1 ${type === "password" && "input_withicon end"
            }`}
        >
          <input
            type={inputType}
            className={`${error && "isinvalid"} form-control`}
            value={value || ""}
            disabled={disabled}
            onChange={onchange}
            maxLength={maxLength || ''}
            name={name}
            autoComplete="new-password"

          />
          {type === "password" && (
            <i
              className="far fa-eye  icn p-2 text_gray"
              onClick={() => handlepasswordIcon(inputType)}
            ></i>
          )}
        </div>
        {error && <span className="font_12 ps-1 text-danger">{error}</span>}
      </div>
    </div>
  );
}

export default InputComponent2;
